
export function hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

export function hexToRgba(hex, opacity) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16) + ',' + opacity : null;
}

export function rgbaToHex(rgba) {
    const match = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (!match) return null;

    const [_, r, g, b, a = '1'] = match;
    const hex = `#${[r, g, b].map(c => parseInt(c).toString(16).padStart(2, '0')).join('')}`;
    return {
        hex,
        opacity: parseFloat(a)
    };
}

export function getThemeColor() {
    return convertColor(window.theme.color)
}

export function getThemeButtonColor() {
    return convertColor(window.theme.buttonColor)
}

export function convertColor(color) {
    const themeColor = {}
    themeColor.hex = color
    themeColor.rgb = hexToRgb(themeColor.hex)
    themeColor.rgbToString = themeColor.rgb.r + ', ' + themeColor.rgb.g + ', ' + themeColor.rgb.b
    return themeColor
}
